import { render, staticRenderFns } from "./info-title.vue?vue&type=template&id=403e623a&"
import script from "./info-title.vue?vue&type=script&lang=ts&"
export * from "./info-title.vue?vue&type=script&lang=ts&"
import style0 from "./info-title.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports